import {createBrowserHistory, createHashHistory} from "history";
import store from "./store/index";
import {currentRouterPath, emitInternalEvent} from "./helper/tracker/internalEvents";
import {createQueryHistory} from "./helper/queryHistory";
import {getBasename, getRouterMode, QUERY_PARAM_NAME, ROUTER_MODES} from "./helper/routerMode";

// legacy name kept for callers; the mode itself lives in helper/routerMode
export const canHandleDeeplinks = () => getRouterMode() === ROUTER_MODES.BROWSER;

const basePath = () => {
    try {
        const manufacturerName = store.getState().config.dealerDetails.dealership.manufacturerName;
        const isGroupShop = !!store.getState().config.garageId || !!store.getState().config.garageGroupId;
        return (isGroupShop && manufacturerName) ? `/brand/${manufacturerName}` : "";
    } catch {
        return "";
    }
};

const createHistoryForMode = mode => {
    switch (mode) {
        case ROUTER_MODES.BROWSER: {
            const basename = getBasename();
            return basename ? createBrowserHistory({basename}) : createBrowserHistory();
        }
        case ROUTER_MODES.QUERY:
            return createQueryHistory({paramName: QUERY_PARAM_NAME});
        default:
            return createHashHistory();
    }
};

const history = createHistoryForMode(getRouterMode());

history.listen(function () {
    emitInternalEvent("navigate", {
        router_path: currentRouterPath(),
        full_url: window.location.href,
    });
});

history["routerMode"] = getRouterMode();
history["entry"] = history.length; // history.location.key was removed
history["pushHome"] = () => history.push(basePath() + "/shop");
history["pushSearch"] = (fuzzy = "") => history.push(basePath() + `/search/${encodeURIComponent(fuzzy)}`);
history["pushCheckout"] = () => history.push(basePath() + "/checkout");
history["pushBookmarks"] = () => history.push(basePath() + "/bookmarks");
history["pushCategory"] = (category = "") => history.push(basePath() + `/products/${category}`);

history["pushProduct"] = (productId, name = "") =>
    history.push(basePath() + `/product/${productId}/${encodeURIComponent(name)}`);

history["getHomeUrl"] = () => basePath() + "/shop";
history["getProductUrl"] = (productId, name = "") =>
    basePath() + `/product/${productId}/${encodeURIComponent(name)}`;
history["getCategoryUrl"] = (category = "") => basePath() + `/products/${encodeURIComponent(category)}/`;

export default history;
